import React, {  useState } from "react";
import "./ProcessListFilters.css";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector } from "react-redux";
import store from "../../../../../store";
import { setSelectedETLProcessList, setSelectedStatus } from "../../../../../features/etlProcessListSlice";
import { Box } from "@mui/system";


export default function ProcessListFiltersItems() {
  const {ETLProcessListData,selectedStatus} =  useSelector(
    (state: any) => state?.ETLProcessList
  );
  const clearFilters = () => {
    store.dispatch(setSelectedStatus([]))
    store.dispatch(setSelectedETLProcessList(null));
  };
;
  const [searchStatus ,setSearchStatus] = useState("")

  const config = [
    {
        key: 'status',
        label: 'Select an Status ',
        searchTerm: searchStatus,
        onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchStatus(e.target.value),
        selectedOption: selectedStatus,
        filterName: 'active',
        data: ETLProcessListData,
        onSelectionChange: (updatedSelection: any) => store.dispatch(setSelectedStatus(updatedSelection)),
        count: selectedStatus && selectedStatus.length,
        colorSelected: selectedStatus !==null && selectedStatus.length > 0 ? '#9C27B0' : '#000000DE',
        multiSelect: false,
        showSearch:false,
        valueMapping: { "true": "Enabled", "false": "Disabled" }
      },
    ]

  return (
    <>
    <Box data-tracker="220">
      <FilterComponent filterConfig={config} clearFilters={clearFilters} />
    </Box>
    </>
  );
}
